import React, { useState, useEffect } from 'react';
import { Logo, Logo1 } from '../Image_exports/MainLogo.jsx';
import { NavLink } from 'react-router-dom';
import '../../CustomAssets/Css/Components/Footer.css';
import { CiPhone } from "react-icons/ci";
import { CiMail } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { CiFacebook } from "react-icons/ci";
import { PiWhatsappLogoLight } from "react-icons/pi";
import { CiInstagram } from "react-icons/ci";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import API_BASE_URL from "../../config.jsx";



const allQuickLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About Us",
    path: "/aboutUs",
  },

  {
    title: "Plans",
    path: "/plans",
  },
  {
    title: "Career",
    path: "/careers",
  },
  {
    title: "Contact Us",
    path: "/contactUs",
  }
];


export default function Footer() {
  const { pathname } = useLocation();

  const [quickLinks, setQuickLinks] = useState(allQuickLinks);

  useEffect(() => {
    const filteredLinks = allQuickLinks.filter((link) => link.path !== pathname);
    setQuickLinks(filteredLinks);
  }, [pathname]);


  const notifyS = () => toast.success('Thanks for showing interest!');
  const notifyF = () => toast.error('Submission failed. Please try again.');

  const initialFormData = {
    email: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}clientLeads/create`, formData);
      if (response.data.statusCode) {
        notifyS();
        resetForm();
      } else {
        notifyF();
      }
    } catch (error) {
      console.error('Submission Failed:', error);
    }
  };



  return (
    <>
      <footer className="footer">
        <div className="container">


          <div className="row section gy-5 gy-xl-0">

            <div className="col-12 col-sm-6 col-xl-2">

              <div id="custom_html-2"
                className="widget_text footer__contact footer-box footer__widget footer-col-1 widget_custom_html">

                <NavLink to={"/"}>
                  <Logo1 clsNm={'footer_logo_size'} />
                </NavLink>

                <div className="textwidget custom-html-widget">
                  <p className="">Welcome to Loansmoney, your trusted source for expert CRM solutions. Our team of professionals conducts thorough analysis to help guide your financial decisions with confidence.</p>
                </div>
              </div>

            </div>
            <div className="col-12 col-sm-6 col-xl-3">
              <div id="custom_html-3"
                className="widget_text footer__contact footer-box footer__widget footer-col-2 widget_custom_html">
                <h4 className="footer__widget-title">Contact</h4>
                <div className="textwidget custom-html-widget">
                  <div className="footer__content">
                    <NavLink to={"/"}>
                      <span className="btn_theme social_box ftr_scl_btn">
                        <CiPhone className='footer_icons' />
                      </span>
                      9749892861 </NavLink>
                    <NavLink to={"/"}> <span className="btn_theme social_box ftr_scl_btn"><CiMail className='footer_icons' />
                    </span>Support@loansmoney.in</NavLink>
                    <NavLink to={"/"}> <span className="btn_theme social_box ftr_scl_btn"> <CiLocationOn className='footer_icons' /></span>
                      Kolkata, New Town </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-xl-2">
              <div id="nav_menu-2" className="footer__contact footer-box footer__widget footer-col-3 widget_nav_menu">
                <h4 className="footer__widget-title">Quick Link</h4>
                <div className="menu-useful-links-container footer_list">
                  <ul id="menu-useful-links " className="menu">

                    {quickLinks.map((qinks, index) => (
                      <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" key={index}>
                        <NavLink to={qinks.path}>{qinks.title}</NavLink>
                      </li>
                    ))}


                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-xl-2">
              <div id="nav_menu-2" className="footer__contact footer-box footer__widget footer-col-3 widget_nav_menu">
                <h4 className="footer__widget-title">LEGAL</h4>
                <div className="menu-useful-links-container footer_list">
                  <ul id="menu-useful-links " className="menu">

                    <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >
                      <NavLink to={"/CompanyDoc"}>Company Doc</NavLink>
                    </li>
                    <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >
                      <NavLink to={"/termsConditions"}>Terms of Conditions</NavLink>
                    </li>
                    <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >
                      <NavLink to={"/privacyPolicy"}>Privacy Policy</NavLink>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-xl-3">
              <div id="text-2" className="footer__contact footer-box footer__widget footer-col-4 widget_text">
                <div className="textwidget">
                  <div className="wpcf7 no-js" id="wpcf7-f3034-o1" lang="en-US" dir="ltr">
                    <div className="screen-reader-response">
                      <p role="status" aria-live="polite" aria-atomic="true"></p>
                      <ul></ul>
                    </div>
                    <form
                      onSubmit={handleSubmit}
                      className="wpcf7-form init" aria-label="Contact form" noValidate="novalidate"
                      data-status="init">
                      <p className="mb_32">Subscribe to get our latest update & news</p>
                      <div className="input-group">
                        <span className="wpcf7-form-control-wrap" data-name="sMail">
                          <input
                            size="40"
                            maxLength="400"
                            className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email form-control ftr_bdr_clr"
                            id="sMail"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Email Address"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </span>
                        <button
                          type="btn"
                          className="emailSubscribe btn_theme wpcf7-form-control wpcf7-submit btn_clr"
                          name="emailSubscribe"
                          id="emailSubscribe"
                          onClick={handleSubmit}
                        >
                          Send
                        </button>
                      </div>

                    </form>

                    <div className="social mt_32">
                      <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><CiFacebook className='footer_icons' /></NavLink>
                      <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><PiWhatsappLogoLight className='footer_icons' /></NavLink>
                      <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><CiInstagram className='footer_icons' /></NavLink>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className="col-12 col-md-12">
              <div className="footer__copyright policyFotter">
                <h4 className="text-center ">Loan Approval & Disbursal Policy</h4>
                <p>At LOANSMONEY, we believe in transparency, security, and ethical lending practices. We collaborate with registered Banks and NBFCs across India to facilitate loans responsibly, in full compliance with regulatory guidelines. <span className='ftr_txt_clr'><strong>However, all loan approvals and rejections are subject to the independent policies and discretion of the respective Banks or NBFCs.</strong></span></p>
              </div>

              <div className="footer__copyright policyFotter">
                <h4 className="text-center ">Our Reach</h4>
                <p>We proudly serves individuals and businesses across India, including major states such as Maharashtra, Delhi, West Bengal, Karnataka, Tamil Nadu, Uttar Pradesh, Gujarat, Rajasthan, Bihar, and Madhya Pradesh — empowering people through responsible financial solutions.</p>
              </div>


              <div className='row'>

                <div className='col-md-6'>

                  <div className="footer__copyright policyFotter footer__contact footer_listBox">
                    <h4 className="text-center">We Will Never Ask For</h4>
                    <ul id="menu-useful-links " className="menu">
                      <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >Debit/Credit Card Numbers</li>
                      <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >CVV or ATM PINs</li>
                      <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >OTPs or Net Banking Passwords</li>
                      <li id="menu-item-165" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-165" >Any sensitive bank login credentials</li>
                    </ul>
                    <p className='ftr_txt_clr'>If you receive any such request claiming to be from LOANSMONEY, <strong>report it immediately</strong> to: <strong>support@loansmoney.in</strong></p>
                  </div>

                </div>

                <div className='col-md-6'>
                  <div className="footer__copyright policyFotter footer__contact footer_listBox">
                    <h4 className="text-center">No Upfront Charges</h4>
                    <p> LOANSMONEY does not charge any upfront or hidden fees for loan approvals or disbursals. All applications are subject to assessment by our partnered financial institutions and are processed in accordance with their eligibility and underwriting policies.</p>

                    <p className=''>We do not guarantee loan approval or disbursement without due verification and documentation. If you encounter any unauthorized individual or message claiming instant loan guarantees or demanding payment, contact us at support@loansmoney.in.</p>

                  </div>
                </div>


              </div>
            </div>

          </div>


          <div className="row">
            <div className="col-12">
              <div className="footer__copyright">
                <p className="copyright text-center">Copyright © 2024<NavLink to={"/"}>LOANSMONEY</NavLink> All Rights Reserved
                </p>
                <div className="right">
                  <ul id="menu-footer-menu" className="footer__menu">
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-156 nav-item">
                      <NavLink to={"/termsConditions"} title="Terms &#038; Conditions"
                        className="nav-links">Terms &#038; Conditions</NavLink>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-156 nav-item">
                      <NavLink to={"/privacyPolicy"} title="Terms &#038; Conditions"
                        className="nav-links">Privacy Policy</NavLink>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2861 nav-item">
                      <NavLink to={"/contactUs"} title="Help &amp; Support" className="nav-links">Help
                        &#038; Support</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>

      </footer >
    </>
  )
}
